import {
	AppstoreOutlined,
	HeartOutlined,
	IdcardOutlined,
	InboxOutlined,
	SolutionOutlined,
} from "@ant-design/icons";
import type { ReactNode } from "react";

export interface NavItem {
	path: string;
	label: string;
	icon: ReactNode;
	/** Shown under the page title in the header. */
	description: string;
}

export interface NavSection {
	title: string;
	items: NavItem[];
}

export const navSections: NavSection[] = [
	{
		title: "Asosiy",
		items: [
			{
				path: "/dashboard",
				label: "Umumiy ko'rinish",
				icon: <AppstoreOutlined />,
				description: "Yordam taqsimoti bo'yicha asosiy ko'rsatkichlar",
			},
			{
				path: "/aid-records",
				label: "Yordamlar",
				icon: <HeartOutlined />,
				description: "Berilgan yordamlar ro'yxati va holati",
			},
		],
	},
	{
		title: "Ma'lumotlar",
		items: [
			{
				path: "/persons",
				label: "Shaxslar",
				icon: <IdcardOutlined />,
				description: "Yordam oluvchilar va xodimlar bazasi",
			},
			{
				path: "/items",
				label: "Mahsulotlar",
				icon: <InboxOutlined />,
				description: "Tarqatiladigan mahsulotlar va o'lchov birliklari",
			},
			{
				path: "/positions",
				label: "Lavozimlar",
				icon: <SolutionOutlined />,
				description: "Xodimlar lavozimlari ro'yxati",
			},
		],
	},
];

export const navItems: NavItem[] = navSections.flatMap((section) => section.items);

export function findNavItem(pathname: string): NavItem | undefined {
	return navItems.find((item) => pathname.startsWith(item.path));
}
